module.exports = __webpack_public_path__ + "img/tc.18777018.svg";